import { useTranslation } from 'react-i18next'
import { Stack } from '@mui/material'
import DateFilter from 'components/DateFilter'
import useFilters from '../../store'
import Status from './Status'
import TextFilter from 'components/TextFilter'


const Filters = () => {
  const { t } = useTranslation()
  const [filters, setFilters] = useFilters()

  const handleDateChange = (key: 'publish_start_at' | 'publish_end_at', value: Date | null) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }))
  }
  return (
    <Stack direction={'row'} gap={1}>
      <TextFilter
        placeholder={t('advertisements.filters.text_field_placeholder')}
        value={filters.verbatim}
        onChange={(value) =>
          setFilters((prev) => ({ ...prev, verbatim: value }))
        }
      />
      <DateFilter
        placement='right-start'
        onReset={() => {
          setFilters((prev) => ({
            ...prev,
            publish_start_at: null,
            publish_end_at: null,
          }))
        }}
        startDate={filters.publish_start_at}
        endDate={filters.publish_end_at}
        onStartDateChange={(value: Date | null) => {
          handleDateChange('publish_start_at', value)
        }}
        onEndDateChange={(value: Date | null) => {
          handleDateChange('publish_end_at', value)
        }}
        placeholderKey={'advertisements.filters.diffusion_date'}
        showPresets={true}
      />
      <Status />
    </Stack>
  )
}

export default Filters
